<template>
  <div class="hero-container">
    <img src="@/assets/logocierre.png" @click="volverInicio" alt="Logo" class="main-logo" />

    <div class="bottom-bar">
      <img src="@/assets/logosintel.png" alt="HP y RM" class="logo-central" />
    </div>
 
  </div>
</template>

<script>
export default {
  data() {
    return {
      redireccionCancelada: false,
      timeoutID: null,
    };
  },
  methods: {
    volverInicio() {
      this.redireccionCancelada = true; // Marca que el usuario ya tomó acción
      clearTimeout(this.timeoutID); // Cancela el timeout si sigue activo
      this.$store.dispatch('clearData');
      this.$router.push('/');
    },
  },
  mounted() {
    this.timeoutID = setTimeout(() => {
      if (!this.redireccionCancelada) {
        this.volverInicio();
      }
    }, 10000); // 10 segundos
  },
};
</script>

<style lang="scss" scoped>
.hero-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(to right, #48465c 0%, #211f2e 50%, #151d2b 100%);
  height: 100vh;
  width: 100vw;
  font-family: 'FormaDJRDisplay', sans-serif;
  position: relative;
  padding: 20px;
  box-sizing: border-box;
}

.main-logo {
  width: 100vw;
  // max-width: 360px;
  height: auto;
  margin-bottom: 10vh;
  cursor: pointer;
}

.start-button {
  font-size: 1.8rem;
  color: white;
  background-color: transparent;
  border-top: 1px solid white;
  border-bottom: 1px solid white;
  padding: 0.75rem 2rem;
  width: 100vw;
  position: absolute;
  bottom: 5%;
  left: 0;
  right: 0;
  margin: auto;
  display: block;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;

  &:hover {
    background-color: white;
    color: #0095d9;
  }
}

.bottom-bar {
  text-align: center;
  width: 100vw;
  position: absolute;
  bottom: 10vh;
  right: 0;
  left: 0;
  top: auto;
  margin: auto;
  display: flex;
  justify-content: center;
  img {

    max-width:60vw;
  }
  // padding: 0.5rem 2rem 1.5rem 2rem;
}
</style>
